// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3r0JH","content":"styles_content__1COIh","checkbox":"styles_checkbox__D7Jp4","checkboxLabel":"styles_checkboxLabel__38Q4R"};